import { computeStandings } from '@/engine';
import { useMemo } from 'react';
import { roundProgressLabel } from '@/lib/match-format';
import { StandingsTable } from './standings-table';
import { MatchCard } from './match-card';
import type { Match, Participant } from '@/data/types';

interface Props {
  matches: Match[];
  participants: Participant[];
  onSelectMatch?: (match: Match) => void;
  placeByParticipant?: Map<string, string>;
}

export function RoundRobinView({ matches, participants, onSelectMatch, placeByParticipant }: Props) {
  const standings = useMemo(
    () => computeStandings(matches, participants.map((p) => p.id)),
    [matches, participants]
  );

  // Группируем матчи по турам
  const rounds = Array.from(new Set(matches.map((m) => m.round))).sort((a, b) => a - b);

  return (
    <div className="space-y-8">
      <section>
        <div className="td-h3" style={{ marginBottom: 12 }}>Таблица</div>
        <StandingsTable standings={standings} participants={participants} />
      </section>

      <section className="space-y-6">
        <div className="td-h3" style={{ marginBottom: 12 }}>Матчи по турам</div>
        {rounds.map((round) => {
          const inRound = matches.filter((m) => m.round === round);
          return (
            <div key={round}>
              <div className="t-eyebrow" style={{ marginBottom: 8 }}>
                Тур {round} {roundProgressLabel(inRound)}
              </div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(248px, 1fr))',
                  gap: 12,
                }}
              >
                {inRound.map((m) => (
                  <MatchCard
                    key={m.id}
                    match={m}
                    onClick={() => onSelectMatch?.(m)}
                    placeByParticipant={placeByParticipant}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
